import React from 'react'; 

const JournalPageCard = ({header, paragraphs}) => {
    if (header == null) {
        return (
            <div className="page-card">
                <div className="w-100 mr3">
                    {paragraphs.map((paragraph) => {
                        return (
                            <p>{paragraph}</p>
                        )
                    })}
                </div>
            </div>
        )
    }

    return (
        <div className="page-card">
            <div className="w-100 mr3">
                <h5>{header}</h5>
                {paragraphs.map((paragraph) => {
                    return (
                        <p>{paragraph}</p>
                    )
                })}
            </div>
        </div>
    );
}

export default JournalPageCard; 